import './bootstrap';
import 'bootstrap';

import 'laravel-datatables-vite';


import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-ui/dist/jquery-ui';






import flatpickr from "flatpickr";
import { French as FlatFrench} from "flatpickr/dist/l10n/fr.js";
window.flatpickr = flatpickr;
window.French = FlatFrench;
flatpickr.localize(FlatFrench);


import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";
window.monthSelectPlugin = monthSelectPlugin;



// import 'select2';

// import 'script-loader!select2/dist/js/select2.js';
import select2 from 'select2';
// import fr from 'select2/dist/js/i18n/fr.js';

// import {"select2/i18n/fr"} from 'select2/dist/js/i18n/fr.js';

// const FrTranslation=require("select2/dist/js/i18n/fr.js");
// const Translation=require("select2/src/js/select2/translation");
// Translation._cache["./i18n/fr"]=FrTranslation;
// Translation._cache["fr"]=FrTranslation;
// $.fn.select2.amd.define('select2/i18n/fr',[],require("select2/dist/js/i18n/fr"));



select2();

import { Calendar } from '@fullcalendar/core'
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

import frLocale from '@fullcalendar/core/locales/fr';

window.Calendar = Calendar;
window.bootstrap5Plugin = bootstrap5Plugin;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.frLocale = frLocale;





// window.select2 = select2;
